<div class="tribe-common-l-container tribe-events-l-container">
    <h1 class="heading_title__1bzno" style="margin-top: 30px;">{{ userDetails?.username }}: Replies</h1>
</div>
<div class="wil-dashboard wil-content container">
    <section class="wil-section wil-dashboard-inner pd-0">
        <div class="dashboard-content_module__zpEtP clearfix">
            <div class="dashboard__sidebar js-sticky filters-container forum-user-sidebar">
                <div class="utility-box-1_module__MYXpX wil-text-center dashboard-profile-img">
                    <div class="utility-box-1_avatar__DB9c_ rounded-circle"
                        [ngStyle]="{ 'background-image': 'url(' + profileImage + ')' }">
                        <img alt="" [src]="profileImage">
                    </div>
                    <div class="utility-box-1_body__8qd9j">
                        <div class="utility-box-1_group__2ZPA2 ng-star-inserted">
                            <h3 class="utility-box-1_title__1I925">{{ userDetails?.display_name || userDetails?.username
                                }}</h3>
                        </div>
                    </div>
                </div>
                <div class="dashboard-nav_module__3c0Pb list-none pos-r">
                    <ul>
                        <li>
                            <a [routerLink]="['/forums/users', userDetails?.username]"
                                [routerLinkActiveOptions]="{exact: true}" routerLinkActive="dashboard-link-active"
                                class="dashboard-nav_link__2BmK9 text-ellipsis color-primary--hover">
                                <span class="dashboard-nav_text__x-_IZ">Profile</span>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/forums/users', userDetails?.username, 'topics']"
                                routerLinkActive="dashboard-link-active"
                                class="dashboard-nav_link__2BmK9 text-ellipsis color-primary--hover">
                                <span class="dashboard-nav_text__x-_IZ">Topics</span>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/forums/users', userDetails?.username, 'replies']"
                                routerLinkActive="dashboard-link-active"
                                class="dashboard-nav_link__2BmK9 text-ellipsis color-primary--hover">
                                <span class="dashboard-nav_text__x-_IZ">Replies</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="dashboard__content forum-user-content pt-0">
                <div *ngIf="replies?.length > 0" id="wilcity-review-wrapper" class="pos-r">
                    <div *ngFor="let comment of replies; let index=index" class="comment-review_module__-Z5tr">
                        <div [id]="'single_reply_'+comment.id" class="reply-inner">
                            <div class="comment-review_header__1si3M forum-reply-header">
                                <div
                                    class="utility-box-1_module__MYXpX utility-box-1_boxLeft__3iS6b clearfix utility-box-1_sm__mopok review-author-avatar">
                                    <div class="utility-box-1_body__8qd9j">
                                        <div class="utility-box-1_description__2VDJ6">{{
                                            comment.created_at | date: 'MMMM d, y, h:mm:ss a' }} in reply to: <a
                                                class="reply-linkto-topic"
                                                [routerLink]="['/forums/topic/', comment.topic.slug]">{{
                                                comment.topic.title }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="forum-reply-body">
                                <div class="forum-reply-body-left">
                                    <a class="utility-box-1_avatar__DB9c_ rounded-circle"
                                        [ngStyle]="{'background-image': 'url(' + getCommentAvatar(comment.profile_photo) + ')'}"></a>
                                    <div class="utility-box-1_group__2ZPA2">
                                        <h3 class="utility-box-1_title__1I925"><a title="View Profile">{{
                                                comment.display_name || comment.username }}</a>
                                        </h3>
                                    </div>
                                </div>
                                <div class="forum-reply-body-right">
                                    <div class="comment-review_body__qhUqq">
                                        <div class="comment-review_content__1jFfZ">
                                            <div class="wilcity-review-content wilcity-review-content-17458">
                                                <div [innerHTML]="comment.content">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>